// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCQpSignatureModelItem } from './tCQpSignatureModelItem.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Role
*/
export class TCQpSignatureModelTabList {
    /**
    * @description Role
    */
    'items': Array<TCQpSignatureModelItem>;
    /**
    * @description Name
    */
    'name': string;
    /**
    * @description Value
    */
    'value': string;
    /**
    * @description AnchorString
    */
    'anchorString': string;
    /**
    * @description AnchorUnits
    */
    'anchorUnits': string;
    /**
    * @description AnchorXOffset
    */
    'anchorXOffset': string;
    /**
    * @description AnchorYOffset
    */
    'anchorYOffset': string;
    /**
    * @description Width
    */
    'width': string;
    /**
    * @description Height
    */
    'height': string;
    /**
    * @description PageNumber
    */
    'pageNumber': string;
    /**
    * @description XPosition
    */
    'xPosition': string;
    /**
    * @description YPosition
    */
    'yPosition': string;
    /**
    * @description Required
    */
    'required': boolean;
    /**
    * @description Role
    */
    'role': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelTabList>> = [
        {
            "name":     "items",
            "baseName": "items",
            "type":     "Array<TCQpSignatureModelItem>"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "anchorString",
            "baseName": "anchorString",
            "type":     "string"
        },
        {
            "name":     "anchorUnits",
            "baseName": "anchorUnits",
            "type":     "string"
        },
        {
            "name":     "anchorXOffset",
            "baseName": "anchorXOffset",
            "type":     "string"
        },
        {
            "name":     "anchorYOffset",
            "baseName": "anchorYOffset",
            "type":     "string"
        },
        {
            "name":     "width",
            "baseName": "width",
            "type":     "string"
        },
        {
            "name":     "height",
            "baseName": "height",
            "type":     "string"
        },
        {
            "name":     "pageNumber",
            "baseName": "pageNumber",
            "type":     "string"
        },
        {
            "name":     "xPosition",
            "baseName": "xPosition",
            "type":     "string"
        },
        {
            "name":     "yPosition",
            "baseName": "yPosition",
            "type":     "string"
        },
        {
            "name":     "required",
            "baseName": "required",
            "type":     "boolean"
        },
        {
            "name":     "role",
            "baseName": "role",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelTabList.attributeTypeMap;
    }
}
